const HAPTIC_PATTERNS = {
  tap: [7],
  open: [9],
  close: [6],
  selection: [10],
  success: [26],
  info: [14],
  warning: [28, 38, 28],
  error: [42, 55, 42],
  heavy: [48]
};

const TOAST_HAPTIC_DEDUP_MS = 450;
let lastHapticAt = 0;
let lastHapticType = '';

const isIOSDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  return /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const haptic = (type = 'tap') => {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  if (isIOSDevice()) return;
  if (typeof localStorage !== 'undefined' && localStorage.getItem('user_haptics_enabled') === 'false') return;

  try {
    navigator.vibrate(HAPTIC_PATTERNS[type] || HAPTIC_PATTERNS.tap);
    lastHapticAt = Date.now();
    lastHapticType = type;
  } catch {
    // Some browsers expose the API but block it by policy.
  }
};

export const vibrateForToast = (type = 'info') => {
  if (lastHapticType === type && Date.now() - lastHapticAt < TOAST_HAPTIC_DEDUP_MS) return;
  haptic(type);
};
